module.exports = __webpack_public_path__ + "static/media/step_6.dc038730.mp3";